export const LOAD_PAYMENT_TYPES = 'LOAD_PAYMENT_TYPES'
export const ADD_PAYMENT_TYPE = 'ADD_PAYMENT_TYPE'
export const DELETE_PAYMENT_TYPE = 'DELETE_PAYMENT_TYPE'
export const LOAD_PAYMENT_STATUS = 'LOAD_PAYMENT_STATUS'
export const ADD_PAYMENT_CONDITION = 'ADD_PAYMENT_CONDITION'
export const DELETE_PAYMENT_CONDITION = 'DELETE_PAYMENT_CONDITION'
export const LOAD_PAYMENT_CONDITIONS = 'LOAD_PAYMENT_CONDITIONS'

